var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('ul',[_vm._l((_vm.availableRoutes),function(route,i){return [_c('router-link',{key:("route-tab-" + i),attrs:{"to":_vm.$_.isFunction(route.to) ? route.to(_vm.vm) : route.to,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:{
            'is-active': _vm.tabIsActive(
              route,
              route.exact ? isExactActive : isActive
            )
          }},[_c('a',{attrs:{"role":"link"},on:{"click":navigate}},[_vm._v(_vm._s(route.label))])])]}}],null,true)})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }